import React from 'react';
import { SectionHeader, SectionWrap, ButtonSecoundry } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import './Copywrites.css';
import { useTranslation } from 'react-i18next';


function Copywrites() {
  const { t, i18n } = useTranslation();
    
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage copywrites'>
        </div>
        <div className='containerNew'>
            <SectionWrap>
            <SectionHeader title={t('fieldsShort4')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
                <span>{t('fieldsPage4Span1')}</span>
                <p>{t('fieldsPage4p1')}</p>
                <span>{t('fieldsPage4Span2')}</span>
                <p>{t('fieldsPage4p2')}</p>
                <ul className='listProperty'>
                    <li>{t('fieldsPage4Li1')}</li>
                    <li>{t('fieldsPage4Li2')}</li>
                    <li>{t('fieldsPage4Li3')}</li>
                    <li>{t('fieldsPage4Li4')}</li>
                    <li>{t('fieldsPage4Li5')}</li>                    
                </ul>
                <span>{t('fieldsPage4Span3')}</span>
                <p>{t('fieldsPage4p3')}</p>
                <p>{t('fieldsPage4p4')}</p>
            </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Copywrites